import { Routes, Route, Navigate } from 'react-router-dom'
import { useEffect } from 'react'
import { useAuthStore } from '@/stores/authStore'
import { useWhiteLabelStore } from '@/stores/whiteLabelStore'
import AppLayout from '@/components/layout/AppLayout'
import AuthLayout from '@/components/layout/AuthLayout'
import PublicLayout from '@/components/layout/PublicLayout'
import LoginPage from '@/pages/auth/LoginPage'
import RegisterPage from '@/pages/auth/RegisterPage'
import OnboardingPage from '@/pages/auth/OnboardingPage'
import DashboardPage from '@/pages/app/DashboardPage'
import PrivateRoute from '@/components/auth/PrivateRoute'
import { OnboardedRoute } from '@/components/auth/OnboardedRoute'
import CampaignNewPage from '@/pages/app/CampaignNewPage'
import CampaignDetailPage from '@/pages/app/CampaignDetailPage'
import CampaignsPage from '@/pages/app/CampaignsPage'
import CRMPage from '@/pages/app/CRMPage'
import LandingPagesPage from '@/pages/app/LandingPagesPage'
import LeadsPage from '@/pages/app/LeadsPage'
import WhatsAppPage from '@/pages/app/WhatsAppPage'
import FunnelsPage from '@/pages/app/FunnelsPage'
import FunnelEditorPage from '@/pages/app/FunnelEditorPage'

export default function App() {
  const { initAuth } = useAuthStore()
  const { initWhiteLabel } = useWhiteLabelStore()
  useEffect(() => { initAuth(); initWhiteLabel() }, [])
  return (
    <Routes>
      <Route element={<PublicLayout />}>
        <Route path="/lp/:slug" element={<div>Landing Page</div>} />
      </Route>
      <Route element={<AuthLayout />}>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/cadastro" element={<RegisterPage />} />
      </Route>
      <Route element={<PrivateRoute />}>
        <Route path="/onboarding" element={<OnboardingPage />} />
        <Route element={<OnboardedRoute />}>
          <Route element={<AppLayout />}>
            <Route path="/dashboard" element={<DashboardPage />} />
            <Route path="/campanhas" element={<CampaignsPage />} />
            <Route path="/campanhas/nova" element={<CampaignNewPage />} />
            <Route path="/campanhas/:id" element={<CampaignDetailPage />} />
            <Route path="/crm" element={<CRMPage />} />
            <Route path="/leads" element={<LeadsPage />} />
            <Route path="/landing-pages" element={<LandingPagesPage />} />
            <Route path="/whatsapp" element={<WhatsAppPage />} />
            <Route path="/funis" element={<FunnelsPage />} />
            <Route path="/funis/:campaignId" element={<FunnelEditorPage />} />
            <Route path="/email" element={<div className="text-white">Email</div>} />
            <Route path="/relatorios" element={<div className="text-white">Relatórios</div>} />
            <Route path="/configuracoes" element={<div className="text-white">Configurações</div>} />
            <Route path="/upgrade" element={<div className="text-white">Upgrade</div>} />
          </Route>
        </Route>
      </Route>
      <Route path="/" element={<Navigate to="/dashboard" replace />} />
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  )
}